module.exports = __webpack_public_path__ + "img/largeloader_parked.24d0f105.svg";